import { EnumBase } from 'hay-core-react';
class UsuarioLogTipologEnum extends EnumBase {
    constructor() {
        super([
            'main.usuariologacesso.tipolog.conexao',
            'main.usuariologacesso.tipolog.desconexao',
        ]);
    }
}

const instance = new UsuarioLogTipologEnum();
export default instance;
